import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=7f5a2058&"
import script from "./AppFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=7f5a2058&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports